<template>
    <p class="w-full pb-4">
        <slot/>
    </p>
</template>
